/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {assertInterpolationSymbols} from '../assertions';

export class InterpolationConfig {
/**
 * @param {?} markers
 * @return {?}
 */
static fromArray(markers: [string, string]): InterpolationConfig {
    if (!markers) {
      return DEFAULT_INTERPOLATION_CONFIG;
    }

    assertInterpolationSymbols('interpolation', markers);
    return new InterpolationConfig(markers[0], markers[1]);
  }
/**
 * @param {?} start
 * @param {?} end
 */
constructor(public start: string,
public end: string){};
}

function InterpolationConfig_tsickle_Closure_declarations() {
 /** @type {?} */
InterpolationConfig.prototype.start;
 /** @type {?} */
InterpolationConfig.prototype.end;
}


export const /** @type {?} */ DEFAULT_INTERPOLATION_CONFIG: InterpolationConfig =
    new InterpolationConfig('{{', '}}');

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
